import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';
import type { SelectedStep } from '~/server/logic/prisma/step-select';
import { atomWithDebounce } from './utils/atomWithDebounce';
import type { Environment } from '@prisma/client';

export const unpolishedStepsAtom = atom<Set<string>>(new Set([]));
// Use operation Id as key
export const activeStepAtom = atomWithReset<SelectedStep | undefined>(undefined);

export const selectedStepsIdsAtom = atomWithReset<string[]>([]);
export const selectedOpsIdsAtom = atomWithReset<string[]>([]);

export const clearSelectionsAtom = atom(null, (_get, set) => {
  set(selectedStepsIdsAtom, []);
  set(selectedOpsIdsAtom, []);
});

export const expandOrCollapseAllAtom = atom<'expand' | 'collapse' | undefined>(undefined);
export const selectedOperationIdAtom = atomWithReset<string | undefined>(undefined);
export const openCodeDialogOpIdAtom = atom<string | undefined>(undefined);
export const erroredOperationAtom = atomWithReset<{ id: string; errorText?: string } | undefined>(undefined);

// Debounce the search keyword to avoid too many re-renders
export const stepSearchBarKeywordAtom = atomWithDebounce<string | undefined>(undefined, 120);
export const stepSearchBarVisibilityAtom = atom<boolean>(false);
export const stepIdToScrollToAtom = atom<string | undefined>(undefined);

export const isMultitabTestAtom = atom(false);

// Only steps that are filtered in by the search keywords are shown in the UI and can be acted on.
export const filteredStepsAtom = atom<SelectedStep[]>([]);

export const currentEnvironmentAtom = atom<Environment>('PRODUCTION');

// Steps and operations will show debug info in the UI
export const debugModeAtom = atom(false);

// Component modification warning state
export const componentModificationWarningAtom = atomWithReset<
  | {
      // The specific component being modified
      componentId: string;
      rootOperationId?: string;
      currentTestContentId: string;
      onConfirm: () => Promise<void>;
    }
  | undefined
>(undefined);
